import React from 'react';

const MaestroIcon = ({
  primaryColor = '#0f0a0a', // dark
  secondaryColor = '#6c63ff', // accent
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 35 36"
      width="100%"
      height="100%"
      aria-label="Maestro"
    >
      {/* Circle - left module */}
      <circle cx="12" cy="18" r="7" fill={secondaryColor} />

      {/* Rectangle - right module */}
      <rect
        x="19"
        y="9"
        width="11"
        height="18"
        rx="3"
        ry="3"
        fill={primaryColor}
      />

      {/* Diagonal connector */}
      <rect
        x="12"
        y="15"
        width="12"
        height="4.4"
        rx="2.2"
        ry="2.2"
        fill={primaryColor}
        transform="rotate(-20 19 17)"
        opacity="0.9"
      />
    </svg>
  );
};

export default MaestroIcon;
